module.exports = __webpack_public_path__ + "static/media/medical-release-forms-thumbnail.5229ccc7.jpg";